module.exports = __webpack_public_path__ + "img/page-bg-default.65f19c5b.svg";